/**
 * Storefront navigation — hrefs match routes in App.jsx.
 */

export const STOREFRONT_ROUTES = {
  newParts: "/catalog?spareType=new",
  usedParts: "/catalog?spareType=used",
  garageServices: "/garages",
  brands: "/brands",
  deals: "/offers",
  trackOrder: "/myorder",
  becomeSeller: "/signup",
  listGarage: "/list-your-garage",
  help: "/support",
};

export const TRACK_ORDER_LEGACY_PATH = "/track-order";

export function isStorefrontTabActive(tab, pathname, search = "") {
  try {
    return tab.match(pathname, search);
  } catch {
    return false;
  }
}

export function isUtilityLinkActive(link, pathname) {
  if (link.match) return link.match(pathname);
  return pathname === link.href || pathname.startsWith(`${link.href}/`);
}

export const PRIMARY_NAV_TABS = [
  {
    id: "new-parts",
    label: "New Parts",
    href: STOREFRONT_ROUTES.newParts,
    match: (pathname, search) => {
      if (pathname === "/") return true;
      if (
        !pathname.startsWith("/catalog") &&
        !pathname.startsWith("/oem-catalogue")
      ) {
        return false;
      }
      return new URLSearchParams(search).get("spareType") !== "used";
    },
  },
  {
    id: "used-parts",
    label: "Used Parts",
    href: STOREFRONT_ROUTES.usedParts,
    match: (pathname, search) => {
      if (
        !pathname.startsWith("/catalog") &&
        !pathname.startsWith("/oem-catalogue")
      ) {
        return false;
      }
      return new URLSearchParams(search).get("spareType") === "used";
    },
  },
  {
    id: "garage-services",
    label: "Garage Services",
    shortLabel: "Garage",
    href: STOREFRONT_ROUTES.garageServices,
    match: (pathname) =>
      pathname === "/garages" || pathname.startsWith("/service/"),
  },
  {
    id: "brands",
    label: "Brands",
    href: STOREFRONT_ROUTES.brands,
    match: (pathname) =>
      pathname === "/brands" || pathname.startsWith("/brands/"),
  },
  {
    id: "deals",
    label: "Deals",
    href: STOREFRONT_ROUTES.deals,
    match: (pathname) =>
      pathname === "/offers" || pathname.startsWith("/offers/"),
  },
  {
    id: "track-order",
    label: "Track Order",
    shortLabel: "Track",
    href: STOREFRONT_ROUTES.trackOrder,
    match: (pathname) =>
      pathname === "/myorder" || pathname === TRACK_ORDER_LEGACY_PATH,
  },
  {
    id: "become-seller",
    label: "Become a Seller",
    shortLabel: "Seller",
    href: STOREFRONT_ROUTES.becomeSeller,
    match: (pathname) => pathname === "/signup",
  },
  {
    id: "list-garage",
    label: "List your Garage",
    shortLabel: "List Garage",
    href: STOREFRONT_ROUTES.listGarage,
    match: (pathname) => pathname === "/list-your-garage",
  },
];

export const UTILITY_NAV_LINKS = [
  {
    label: "Help",
    href: STOREFRONT_ROUTES.help,
    match: (pathname) =>
      pathname === "/support" ||
      pathname === "/faq" ||
      pathname === "/contact",
  },
];

/** Main header marketplace tabs (HTML mockup — not utility/topbar links). */
export const HEADER_MARKETPLACE_NAV_TABS = PRIMARY_NAV_TABS.filter((tab) =>
  ["new-parts", "used-parts", "garage-services", "brands", "deals"].includes(
    tab.id
  )
);

/** Top announcement bar — quick links only (browse lives in Account menu). */
export const TOPBAR_UTILITY_LINKS = [
  PRIMARY_NAV_TABS.find((t) => t.id === "track-order"),
  {
    id: "garages",
    label: "Garages",
    href: STOREFRONT_ROUTES.garageServices,
    match: (pathname) =>
      pathname === "/garages" || pathname.startsWith("/garages/"),
  },
].filter(Boolean);

export const STOREFRONT_NAV_TABS = [
  ...PRIMARY_NAV_TABS,
  {
    id: "help",
    label: "Help",
    href: STOREFRONT_ROUTES.help,
    match: (pathname) =>
      pathname === "/support" ||
      pathname === "/faq" ||
      pathname === "/contact",
  },
];

/** Marketing header on /list-your-garage — kept in sync with home quick nav. */
export const GARAGE_LANDING_HEADER_LINKS = [
  {
    id: "brands",
    label: "Brands",
    href: STOREFRONT_ROUTES.brands,
  },
  {
    id: "deals",
    label: "Deals",
    href: STOREFRONT_ROUTES.deals,
  },
  {
    id: "track-order",
    label: "Track Order",
    href: STOREFRONT_ROUTES.trackOrder,
  },
  {
    id: "become-seller",
    label: "Sell on SparePe",
    href: STOREFRONT_ROUTES.becomeSeller,
  },
  {
    id: "list-garage",
    label: "List Garage",
    href: `${STOREFRONT_ROUTES.listGarage}#reg-section`,
    scrollOnSamePage: true,
  },
];

/** Home page shortcuts — full storefront tabs (includes all garage-landing routes). */
export const HOME_QUICK_NAV_LINKS = PRIMARY_NAV_TABS.map((tab) => ({
  id: tab.id,
  label: tab.label,
  href: tab.href,
}));
